import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { formatDate } from 'utils/dateUtilities'

const dateCell = (props) => {
  return class DateCell extends GridCell {
    render () {
      const formatedDate = formatDate(this.props.dataItem[this.props.field], this.props.format)
      return (
        <td className='date-cell'>
          {formatedDate}
        </td>
      )
    }
  }
}

export {
  dateCell
}
